<app-confirm-delete-alert #confirmsharedelete></app-confirm-delete-alert>


<ion-label class="ion-text-start askTitle" style="display: flex; align-items: center;">
  <h2 style="margin-right: auto;">{{manager.Trad.Parse("STR_SHARED_WITH")}}</h2>
  <ion-button shape="round" *ngIf="!deployed" (click)="deployed = !deployed">
    <ion-icon name="add" slot="icon-only" color="white"></ion-icon>
  </ion-button>
  <ion-button shape="round" *ngIf="deployed" (click)="deployed = !deployed">
    <ion-icon name="close-outline" slot="icon-only" color="white"></ion-icon>
  </ion-button>
</ion-label>

<ion-item lines="initial" style="--border-width: 0 0 2px 0; border-radius: 25px; margin-top: 0.3rem;" *ngIf="deployed"
  class="share-input-item">
  <ion-input [placeholder]="manager.Trad.Parse('STR_TARGET_EMAIL_PLACEHOLDER')" [(ngModel)]="shareEmail"
    class="font-weight-bold share-email-input" color="secondary">
  </ion-input>

  <ion-button slot="end" shape="round" fill="clear" (click)="openContacts()" *ngIf="manager.Usr.isLoged"
    style="align-self: flex-end; margin-bottom: 8px; height: fit-content">
    <ion-icon name="people" slot="icon-only" color="primary" size="large"></ion-icon>
  </ion-button>
</ion-item>

<ion-list style="text-align: center; background: transparent; margin: 0;padding-top: 0;padding-bottom: 0;"
  *ngIf="deployed">
  <ion-button class=" button button-primary" shape="round" (click)="addContact()" *ngIf="CanAddShare"
    style="align-self: flex-end; margin-bottom: 8px; height: fit-content">
    <ion-text>
      <p *ngIf="!pandingRequest">{{manager.Trad.Parse("STR_SHARE")}}</p>
      <div *ngIf="pandingRequest" class="loading-icon">
        <ion-icon name="refresh-outline"></ion-icon>
      </div>
    </ion-text>
  </ion-button>
</ion-list>

<div *ngIf="!deployed" class="horizontal-chip-scroll">
  <ion-chip *ngFor="let share of Shares" class="share-chip" (click)="presentContactActionSheet(share)">

    <!-- Conditional Icons -->
    <ion-icon *ngIf="CurrentAsk?.OriginalTargetId === share.UserId" name="construct-outline">
    </ion-icon>
    <ion-icon *ngIf="CurrentAsk?.OriginalOwnerId === share.UserId" name="paper-plane-outline">
    </ion-icon>

    <!-- Share Email Label -->
    <ion-label>{{ share.Email }}</ion-label>
  </ion-chip>
</div>

<div class="horizontal-chip-scroll" *ngIf="deployed">
  <ion-chip *ngFor="let share of Shares" class="share-chip" (click)="presentContactActionSheet(share)">

    <!-- Conditional Icons -->
    <ion-icon slot="start" *ngIf="CurrentAsk?.OriginalTargetId === share.UserId" name="construct-outline"></ion-icon>
    <ion-icon slot="start" *ngIf="CurrentAsk?.OriginalOwnerId === share.UserId" name="paper-plane-outline"></ion-icon>

    <!-- Share Details -->
    <ion-label>
      <h2>{{ share.DisplayName }}</h2>
      <p>{{ share.Email }}</p>
    </ion-label>
  </ion-chip>
</div>